import { render, staticRenderFns } from "./BooleanStatusMeasurementItem.vue?vue&type=template&id=59f9b022&scoped=true&"
import script from "./BooleanStatusMeasurementItem.vue?vue&type=script&lang=js&"
export * from "./BooleanStatusMeasurementItem.vue?vue&type=script&lang=js&"
import style0 from "./BooleanStatusMeasurementItem.vue?vue&type=style&index=0&id=59f9b022&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f9b022",
  null
  
)

export default component.exports